module.exports = __webpack_public_path__ + "img/marker_one_red3.05a74061.png";